import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

const initialState = {};

const menuConfigurationSlice = createSlice({
  name: "menuConfiguration",
  initialState,
  reducers: {
    setMenuConfiguration: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setMenuConfiguration } = menuConfigurationSlice.actions;

export default menuConfigurationSlice.reducer;

export const getMenuConfiguration = (state) => state.menuConfiguration;

export const useMenuConfiguration = () => {
  return useSelector(getMenuConfiguration);
};
